import { manufacturingFetch } from "@/lib/manufacturingClient";

export type MfgMaterialIssuanceSummary = {
  id: string;
  plant_id: string;
  material_id: string;
  quantity: number;
  unit_cost_usd: number;
  extended_cost_usd: number;
  deal_id: string | null;
  built_unit_id: string | null;
  mfg_unit_id: string | null;
  issued_at: string;
  notes: string;
};

export type MfgMaterialsReconciliationScope = {
  scope_key: string;
  deal_id: string | null;
  built_unit_id: string | null;
  predicted_materials_usd: number;
  actual_issuance_usd: number;
  variance_usd: number;
};

export type MfgMaterialsReconciliationReport = {
  plant_id: string;
  period_start: string;
  totals: {
    predicted_materials_usd: number;
    actual_issuance_usd: number;
    variance_usd: number;
    scope_count: number;
  };
  scopes: MfgMaterialsReconciliationScope[];
  waste_bucket: {
    bucket_id: string;
    bucket_key: string;
    prior_actual_usd: number | null;
    reconciliation_delta_usd: number;
    projected_actual_usd: number | null;
  } | null;
};

export function createManufacturingMaterialIssuance(payload: {
  plant_id: string;
  material_id: string;
  quantity: number;
  unit_cost_usd?: number;
  deal_id?: string;
  built_unit_id?: string;
  mfg_unit_id?: string;
  notes?: string;
}) {
  return manufacturingFetch<{ ok: true; issuance: MfgMaterialIssuanceSummary }>(
    "/api/mfg/material-issuance/create",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function listManufacturingMaterialIssuances(filters?: {
  plant_id?: string;
  deal_id?: string;
  built_unit_id?: string;
  mfg_unit_id?: string;
  material_id?: string;
  period_start?: string;
}) {
  const q = new URLSearchParams();
  if (filters?.plant_id) q.set("plant_id", filters.plant_id);
  if (filters?.deal_id) q.set("deal_id", filters.deal_id);
  if (filters?.built_unit_id) q.set("built_unit_id", filters.built_unit_id);
  if (filters?.mfg_unit_id) q.set("mfg_unit_id", filters.mfg_unit_id);
  if (filters?.material_id) q.set("material_id", filters.material_id);
  if (filters?.period_start) q.set("period_start", filters.period_start);
  const suffix = q.toString() ? `?${q.toString()}` : "";
  return manufacturingFetch<{ ok: true; events: MfgMaterialIssuanceSummary[] }>(
    `/api/mfg/material-issuance${suffix}`,
    { method: "GET" },
  );
}

export function getManufacturingMaterialsReconciliation(params: {
  plant_id: string;
  period_start?: string;
}) {
  const qs = new URLSearchParams({ plant_id: params.plant_id });
  if (params.period_start) qs.set("period_start", params.period_start);
  return manufacturingFetch<{ ok: true; report: MfgMaterialsReconciliationReport }>(
    `/api/mfg/materials/reconciliation?${qs.toString()}`,
    { method: "GET" },
  );
}
